import { defineStyle } from '@chakra-ui/react';

import colors from '@/styles/themes/brand/colors';

const style = defineStyle({
  root: {
    height: '100%',

    '.carouselItem': {
      padding: {
        base: '0 10px',
        xl: '0 20px',
      },
      minWidth: '185px',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
      position: 'relative',
      borderRight: `1px solid ${colors.border}`,
      gap: '0.5rem',
      flexDirection: 'column',
    },
    '.skeleton-text': {
      w: '100%',
      maxW: '100px',
    },
  },
});

export default style;
